import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from './../../environments/environment';
import { SubUrlsEnum } from './../enums/sub-urls.enum';
import { IBug } from './../interfaces/bug-support.interface';

@Injectable({
    providedIn: 'root',
})
export class BugSupportService {
    constructor(private http: HttpClient) {}

    public postBugReport(bug: IBug): Observable<any> {
        return this.http.post(environment.wasoApi + SubUrlsEnum.SUPPORT, { bug });
    }
}
